import React, { useState } from "react";
import axios from "axios";
import "./Weather.css"; // Import the CSS file
import Rain from './weather-icons/rain.png'
import no from './weather-icons/no.png'
import clearnight from './weather-icons/clear-night.png'
import sun from './weather-icons/sun.png'
import partlycloudy from './weather-icons/partly-cloudy.png'
import partlycloudyNight from './weather-icons/partly-cloudy-night.png'
import mist from './weather-icons/mist.png'
import snow from './weather-icons/snowman.png'
import thunderstorm from './weather-icons/thunderstorm.png'
const Weather = () => {
  const [city, setCity] = useState("Nagpur");
  const [weatherData, setWeatherData] = useState(null);
  const [error, setError] = useState(null);
  const API_KEY = "d28860fefdff84d27d99d36b36c430b5";

  const handleInputChange = (event) => {
    setCity(event.target.value);
  };
  const getWeatherData = async () => {
    try {
      setError(null);
      const response = await axios.get(
        `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${API_KEY}&units=metric`
        );
        setWeatherData(response.data);
    } catch (error) {
      setError("City not found. Please enter a valid city name.");
      setWeatherData(null);
    }
  };

  const getWeatherIcon = (weatherCode) => {
    const iconMap = {
      "01d": sun,
      "01n": clearnight,
      "02d": partlycloudyNight,
      "02n": partlycloudyNight,
      "03d": partlycloudy,
      "03n": partlycloudy,
      "04d": partlycloudy,
      "04n": partlycloudy,
      "09d": Rain,
      "09n": Rain,
      "10d": Rain,
      "10n": Rain,
      "11d": thunderstorm,
      "11n": thunderstorm,
      "13d": snow,
      "13n": snow,
      "50d": mist,
      "50n": mist,
    };
  
    return iconMap[weatherCode] || no;
  };
  return (
    <>
    <div className="weather-container">
    <h2>Weather App</h2>
    <input
      type="text"
      placeholder="Enter city name"
      value={city}
      onChange={handleInputChange}
    />
    <button onClick={getWeatherData}><i class="fa-solid fa-magnifying-glass"></i></button>
    {error && <p className="error-message">{error}</p>}
    {weatherData && !error && (
      <>
      <div className="weather-info">
        <img
              src= {getWeatherIcon(weatherData.weather[0].icon)}
            alt={weatherData.weather[0].main}
            className="weather-icon"
          />
        <span>{weatherData.main.temp} °C</span>
        <span>{weatherData.name}</span>
        <span> {weatherData.weather[0].description}</span>
        <div className="boxes">
        <div className="box">
        <i class="fa-solid fa-smog"></i>
        <span>humidity: {weatherData.main.humidity}%</span> </div>
        <div className="box">
        <i class="fa-solid fa-wind"></i>
        <span>wind-speed: {weatherData.wind.speed} km/H</span> </div>
        </div>
    
          <div class="soc">
          <ul>
            <li>
              <a href="https://www.facebook.com/pravin.nandankar.18" target="_blank"><i class="fa-brands fa-facebook" id="facebook"></i></a>
            </li>
            <li>
              <a href="https://github.com/pravin435916" target="_blank"><i class="fab fa-github" id="github"></i></a>
            </li>
            <li>
              <a href="https://www.linkedin.com/in/pravin-nandankar-a38910275" target="_blank"><i class="fab fa-linkedin" id="linkedin"></i></a>
            </li>
            <li>
              <a href="https://instagram.com/pravin____x9?igshid=ZDc4ODBmNjlmNQ==" target="_blank"><i class="fab fa-instagram" id="insta"></i></a>
            </li>
          </ul>
        </div>
        </div>
      </>
    )}
  </div>
  </>
  );
};

export default Weather;
